/**
 * @generated SignedSource<<cf205ae0437288de09fda1402e095528>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AHTeamIconCircle$data = {
  readonly color: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"AHTeamIcon">;
  readonly " $fragmentType": "AHTeamIconCircle";
};
export type AHTeamIconCircle$key = {
  readonly " $data"?: AHTeamIconCircle$data;
  readonly " $fragmentSpreads": FragmentRefs<"AHTeamIconCircle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AHTeamIconCircle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AHTeamIcon"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "352f2cd30102c730661bf11ac09c5bb5";

export default node;
